export const CHART_COLORS = {
  // Core (used across charts by default)
  primary: '#10BE5A',
  secondary: '#3A4473',
  accent: '#06B6D4',

  // Data Visualization Palette
  chart: {
    green:  '#10BE5A',
    teal:   '#06B6D4',
    blue:   '#2563EB',
    purple: '#6D28D9',
    orange: '#F97316',
    red:    '#D22B2B',
    yellow: '#EAB308',
  },

  // Heat Map Gradient (low → high density)
  heatmap: {
    low:      '#ffffb2',
    medLow:   '#fecc5c',
    medium:   '#fd8d3c',
    medHigh:  '#f03b20',
    high:     '#bd0026',
  },

  // Status / UI Meaning
  status: {
    success: '#10B981',
    warning: '#F97316',
    danger:  '#B72727',
    info:    '#2563EB',
  },

  // Neutrals
  neutral: {
    base: '#D3D3D3',
    soft: '#CBD5E1',
  }
};
